import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import Notifications from '../constants/Notifications';

export default class Robin extends Component {
  /**
   * Initialize the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    window.robin_settings = {
      hide_tab: true,
      mobile_hide_tab: true,
      callback: (event) => {
        if (event !== 'init') return;

        this.el.classList.remove('hidden');
        if (!window.__robin.getOnlineStatus()) return;
        const label = button.querySelector('span');
        if (label) {
          label.innerText = this.el.dataset.contactChatTranslation;
        }
      }
    };
    const robinScript = document.createElement('script');
    robinScript.setAttribute('src', 'https://selfservice.robinhq.com/external/robin/e0xi14gj.js');
    robinScript.setAttribute('async', 'async');
    document.getElementsByTagName('head')[0].appendChild(robinScript);

    const button = this.el.getElementByRef('robin-button');
    if (!button) {
      throw new Error('a button is required');
    }

    const clickHandler = this.onClick.bind(this);
    button.addEventListener(EventNames.CLICK, clickHandler);

    this.addListener(Notifications.ROBIN_CHAT_OPEN, () => {
      setTimeout(() => {
        this.notify(Notifications.LOADED);
        const spinner = document.getElementById('robin-popover-spinner');
        if (spinner) {
          spinner.classList.add('hidden');
        }
      }, 400);
    });

    setTimeout(() => {
      this.addCloseButton();
      this.addLoader();
    }, 4000);
  }

  /**
   * opens the robin contact form on click
   */
  onClick() {
    this.notify(Notifications.ROBIN_CHAT_OPEN);
    const spinner = document.getElementById('robin-popover-spinner');
    if (spinner) {
      spinner.classList.remove('hidden');
    }

    if (window.__robin.getOnlineStatus()) {
      window.__robin.show('chat');
    } else {
      window.__robin.show('contact_form');
    }
  }

  /**
   * adds a close button to the robin chat
   */
  addCloseButton() {
    const popover = document.getElementById('robin_popover');
    if (!popover) {
      setTimeout(() => {
        this.addCloseButton();
      }, 200);
      return;
    }

    const closeButton = document.createElement('button');
    closeButton.classList.add('robin_close_button');

    closeButton.addEventListener(EventNames.CLICK, () => {
      // the original button should be shown as default.
      this.notify(Notifications.ROBIN_CHAT_CLOSE);
      window.__robin.hide();
    });

    popover.appendChild(closeButton);
  }

  addLoader() {
    const popover = document.getElementById('robin_popover');
    if (!popover) {
      setTimeout(() => {
        this.addLoader();
      }, 200);
      return;
    }

    popover.classList.add('overflow-hidden');
    const loaderContainer = document.createElement('div');
    loaderContainer.className = 'absolute w-full h-full top-0 left-0 hidden';
    loaderContainer.id = 'robin-popover-spinner';
    const loader = document.createElement('div');
    loader.className = 'block relative mx-auto top-[50%] -mt-[30px] loader loader--blue loader--fill-content';
    const spinner = document.createElement('span');
    spinner.className = 'loader__spinner absolute animate-spin';

    loaderContainer.appendChild(loader);
    loader.appendChild(spinner);
    popover.appendChild(loaderContainer);
  }
}
